<template>
  <div class="flex justify-center items-start h-full">
    <div class="bg-white shadow-xl w-2/3">
        <div class="bg-gray-400 text-gray-700 p-4 text-lg font-bold">
          Tildel særplass
        </div>
        <form @submit.prevent="doSubmit" class="p-10">

          <div>
            <label class="font-bold block" for="firstName">Student</label>
            <select class="w-full mt-1" v-model="selectedStudentId">
              <option
               v-for="student in students"
               :key="student.studentId"
              :value="student.studentId">
                {{ student.firstName }} {{ student.lastName }} ({{ student.studyDisplay }})
              </option>
            </select>
          </div>

          <div class="mt-6">
            <label class="font-bold block" for="firstName">Apotek</label>
            <div class="relative">
              <button class="w-full text-left p-2 bg-gray-300 outline-none border-2 border-gray-300 rounded focus:outline-none" type="text" @click.prevent="onToggleClick">
                {{ selectedPharmacy ? selectedPharmacy.name : 'Velg' }}
              </button>
              <div class="absolute top-0 w-full h-64 p-2 overflow-y-auto bg-white shadow-md border-2 border-red-500 rounded" v-if="lookupVisible">
                <table class="w-full">
                    <tr>
                      <td class="p-1 w-1/2">
                        <filter-input v-model="nameFilter" placeholder="Navn" />
                      </td>
                      <td class="p-1 w-24">
                        <filter-input v-model="postCodeFilter" placeholder="Postnr." />
                      </td>
                      <td class="p-1">
                        <filter-input v-model="postPlaceFilter" placeholder="Poststed" />
                      </td>
                      <td class="p-1 pb-2 uppercase text-sm font-bold">
                        Ledige
                      </td>
                    </tr>
                  <tr                     
                    @click="onSelectClick(pharmacy.pharmacyId, pharmacy.availableCount)" 
                    class="text-sm cursor-pointer hover:bg-gray-200" 
                    v-for="(pharmacy, index) in filteredPharmacies" 
                    :key="index"
                     :class="{ 'text-gray-400': pharmacy.availableCount === 0}"
                  >
                    <td class="p-1">{{ pharmacy.name }}</td>
                    <td class="p-1">{{ pharmacy.postCode }}</td>
                    <td class="p-1">{{ pharmacy.postPlace }}</td>
                    <td class="p-1 text-center">{{ pharmacy.availableCount }}</td>
                  </tr>
                </table>
              </div>
            </div>

          </div>

          <div class="mt-6" v-if="slots.length > 0 && !hasAvailableSlots">
            <label class="font-bold block" for="firstName">Praksisplasser</label>
            Dette apoteket har ikke flere praksisplasser tilgjengelig. Du kan kontakte studiestedet for et eventuelt bytte innen fristen for tildeling av særplass.
            <div class="mt-4" v-for="(slot, index) in unavailableSlots" :key="index">
              <div class="font-bold">{{ slot.contact.university }}</div>
              <div>{{ slot.contact.name }}</div>
              <div><a class="text-red-500" :href="'tel:' + slot.contact.phone">{{ slot.contact.phone }}</a></div>
              <div><a class="text-red-500" :href="'mailto:' + slot.contact.email">{{ slot.contact.email }}</a></div>
            </div>
          </div>

          <div class="text-center mt-12">
            <button type="submit" class="btn btn-primary w-32 mx-2" :class="{ 'disabled': !selectedPracticeSlotId }" :disabled="!selectedPracticeSlotId">Tildel</button>
            <router-link class="btn w-32 mx-2" :to="{ name: 'pk-special-list' }">Avbryt</router-link>
          </div>
        </form>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import _ from 'lodash'
export default {
  name: 'pk-special-create',
  data () {
    return {
      errors: {},
      students: [],
      pharmacies: [],
      slots: [],
      selectedStudentId: null,
      selectedPharmacyId: null,
      selectedPracticeSlotId: null,
      lookupVisible: false,
      nameFilter: '',
      postCodeFilter: '',
      postPlaceFilter: ''
    }
  },
  computed: {
    selectedStudent () {
      return this.selectedStudentId ? _.find(this.students, s => s.studentId === this.selectedStudentId) : null
    },
    selectedPharmacy () {
      return this.selectedPharmacyId ? _.find(this.pharmacies, s => s.pharmacyId === this.selectedPharmacyId) : null
    },
    hasAvailableSlots () {
      return _.filter(this.slots, s => s.isAvailable).length > 0
    },
    unavailableSlots () {
      return _.filter(this.slots, s => s.isAvailable === false)
    },
    filteredPharmacies () {
      return _.filter(this.pharmacies, p => {
        return (this.nameFilter === '' || p.name.toLowerCase().indexOf(this.nameFilter.toLowerCase()) >= 0) &&
               (this.postCodeFilter === '' || p.postCode.toLowerCase().indexOf(this.postCodeFilter.toLowerCase()) >= 0) &&
               (this.postPlaceFilter === '' || p.postPlace.toLowerCase().indexOf(this.postPlaceFilter.toLowerCase()) >= 0)
      })
    }
  },
  methods: {
    onToggleClick () {
      if (this.selectedStudentId) {
        this.lookupVisible = !this.lookupVisible
      }
    },
    onSelectClick (id, count) {
      if (count > 0) {
        this.selectedPharmacyId = id
        this.lookupVisible = false
      }
    },
    async doSubmit () {
      const response = await api.pk.assignPracticeSlotSpecial(this.selectedPracticeSlotId, this.selectedStudentId)
      if (response.errors) {
        this.errors = response.errors
      } else {
        this.$router.push({ name: 'pk-special-list' })
      }
    },
    onCancel () {
      this.$router.back()
    }
  },
  async created () {
    this.students = await api.pk.getUnslottedStudents()
  },
  watch: {
    selectedStudent: async function (val) {
      this.selectedPharmacyId = null
      this.pharmacies = await api.pk.getPracticeSlotsPharmacies(val.study)
    },
    selectedPharmacyId: async function (val) {
      if (val) {
        const slots = await api.pk.getPharmacySlots(val, this.selectedStudent.study)
        const firstAvailableSlot = _.find(slots, s => s.isAvailable)
        this.slots = slots
        if (firstAvailableSlot) {
          this.selectedPracticeSlotId = firstAvailableSlot.practiceSlotId
        } else {
          this.selectedPracticeSlotId = null
        }
      } else {
        this.slots = []
        this.selectedPracticeSlotId = null
      }
    }
  }
}
</script>

